import { useNavigate } from 'react-router'
import { Paths } from '@/paths'

const SESSION_KEY_LAST_CONTRACTS_SEARCH_URL = 'lastContractsSearchUrl'

export const saveContractsSearchUrl = (url: string): void => {
  sessionStorage.setItem(SESSION_KEY_LAST_CONTRACTS_SEARCH_URL, url)
}

export type BackToContractsSearch = {
  navigateBackToSearch: () => void
  backToSearchUrl: string
}

export const useBackToContractsSearch = (): BackToContractsSearch => {
  const navigate = useNavigate()
  const url = sessionStorage.getItem(SESSION_KEY_LAST_CONTRACTS_SEARCH_URL) ?? Paths.CONTRACTS_SEARCH

  return {
    navigateBackToSearch: () => {
      navigate(url)
    },
    backToSearchUrl: url
  }
}
